<template>
  <div class="min-h-screen flex">
    <!-- 왼쪽 영역 -->
    <div class="flex-1 hidden md:flex items-center justify-center bg-white">
      <img
        src="@/assets/img/scmmain1.png"
        alt="Login Illustration"
        class="max-w-md"
      />
    </div>

    <!-- 오른쪽 영역 (애니메이션 적용) -->
    <transition
      enter-active-class="transform transition duration-700 ease-out"
      enter-from-class="translate-x-full opacity-0"
      enter-to-class="translate-x-0 opacity-100"
    >
      <div
        v-if="showLogin"
        class="flex w-[480px] items-center justify-center p-8 bg-gray-100"
      >
        <div class="w-full max-w-md p-8">
          <!-- 헤더 -->
          <h2 class="text-2xl font-bold text-gray-800">협력사 로그인</h2>

          <!-- 아이디 -->
          <div class="mt-6">
            <!-- <label class="block text-gray-600 text-sm mb-1">아이디</label> -->
            <UCText
              ref="refTxtId"
              v-model="txtId"
              placeholder="아이디"
              :rules="[required('아이디를 입력해주세요')]"
              :required-asterisk="true"
              validate-on="submit"
            />
          </div>

          <!-- 비밀번호 -->
          <div class="mt-4">
            <!-- <label class="block text-gray-600 text-sm mb-1">비밀번호</label> -->
            <UCText
              ref="refTxtPassword"
              v-model="txtPassword"
              type="password"
              placeholder="비밀번호"
              :rules="[required('비밀번호 입력해주세요')]"
              :required-asterisk="true"
              validate-on="submit"
              @keyup.enter="txtPasswordEnter"
            />
            <input
              type="checkbox"
              id="remember"
              v-model="chkRememberMe"
              class="mr-2 mt-4"
            />
            <label for="remember" class="text-sm">아이디 저장</label>
          </div>

          <!-- 버튼들 -->
          <div class="mt-6 space-y-3">
            <!-- <button
            class="w-full py-2 rounded-lg bg-purple-500 text-white font-semibold shadow hover:bg-purple-600 transition"
          > -->
            <button
              class="w-full h-12 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white border-0 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg font-medium"
              @click="btnLoginClick"
            >
              로그인
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserStore } from "@/store/userStore";
import envs from "@/envs";

import { required } from "@/utils/rule";
import UCText from "@/components/UserControl/UCText.vue";

// router, store 인스턴스
const router = useRouter();
const userStore = useUserStore();

// 상태 변수
const showLogin = ref(false);

const txtId = ref("");
const refTxtId = ref(null);

const txtPassword = ref("");
const errorMessages = ref([]);
const chkRememberMe = ref(false);

const refTxtPassword = ref(null);
onMounted(() => {
  // 컴포넌트가 로드되면 애니메이션 시작
  setTimeout(() => {
    showLogin.value = true;
  }, 100); // 살짝 딜레이 주면 부드럽게 표시됨

  const savedId = localStorage.getItem("rememberedId");
  if (savedId) {
    txtId.value = savedId;
    chkRememberMe.value = true;

    // refTxtPassword.value.focus();
  }
});

// 비밀번호 입력 후 엔터 처리
function txtPasswordEnter() {
  btnLoginClick();
}

// 로그인 버튼 클릭
async function btnLoginClick() {
  const v1 = refTxtId.value.validate();
  const v2 = refTxtPassword.value.validate();
  if (!v1 || !v2) return;

  try {
    const res = await userStore.loginByPassword({
      userId: txtId.value,
      userPassword: txtPassword.value,
    });
    // console.log("LoginByPassword res", res);
    if (res.Code === 200) {
      router.push("/scm/home");
      if (chkRememberMe.value) {
        localStorage.setItem("rememberedId", txtId.value);
      } else {
        localStorage.removeItem("rememberedId");
      }
    } else {
      errorMessages.value[0] = "아이디 또는 비밀번호를 다시 확인하세요!";
    }
  } catch (err) {
    console.error("login fail", err);
    errorMessages.value[0] = "아이디 또는 비밀번호를 다시 확인하세요!!";
  }
}
</script>
